export { default } from './DeleteTemplateModal';
